<template>
    <div class="transitions-results">
        <table class="control-table">
            <thead class="control-table__head">
                <tr class="control-table__row">
                    <th data-name="source" class="control-table__cell tokens-table__cell">
                        <span v-t="'crm.transitions.results.source'" />
                    </th>
                    <th data-name="dest" class="control-table__cell tokens-table__cell">
                        <span v-t="'crm.transitions.results.dest'" />
                    </th>
                    <th class="control-table__cell">&nbsp;</th>
                </tr>
            </thead>
            <tbody class="control-table__body">
                <template v-if="!loading">
                    <tr v-if="noData" class="control-table__row">
                        <td class="table__cell table__cell--centered table__empty" colspan="3">
                            <span v-t="'crm.transitions.noData'" />
                        </td>
                    </tr>
                    <tr v-else-if="notFound" class="control-table__row">
                        <td class="table__cell table__cell--centered table__empty" colspan="3">
                            <span v-t="'crm.transitions.noResults'" />
                        </td>
                    </tr>
                </template>
                <tr v-for="item in computedItems" :key="item.id" class="control-table__row">
                    <td class="control-table__cell">
                        <template v-if="item.source">
                            <div class="transitions-results__label" v-text="item.source.label" />
                            <div
                                class="transitions-results__descr"
                                v-text="item.source.description"
                            />
                        </template>
                    </td>
                    <td class="control-table__cell">
                        <template v-if="item.dest">
                            <div class="transitions-results__label" v-text="item.dest.label" />
                            <div
                                class="transitions-results__descr"
                                v-text="item.dest.description"
                            />
                        </template>
                    </td>
                    <td class="control-table__cell control-table__cell--right">
                        <button type="button" class="button button--icon" @click="item.on.edit">
                            <IconPencil />
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { IconPencil } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'TransitionsResults',
    components: {
        IconPencil,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        schema: {
            type: Object,
            default: () => ({}),
        },
        items: {
            type: Array,
            default: () => [],
        },
        isEmpty: {
            type: Boolean,
            default: true,
        },
        notFound: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        noData() {
            const { length } = this.items;
            const { isEmpty } = this;
            return isEmpty || !length;
        },
        computedItems() {
            if (!this.items.length) return [];
            const { locale } = this.$i18n;
            return this.items.map((item) => {
                const { id } = item;
                let { source_state: source, destination_state: dest } = item;

                if (source) {
                    source = {
                        label: source.label[locale],
                        description: source.description[locale],
                    };
                }

                if (dest) {
                    dest = {
                        label: dest.label[locale],
                        description: dest.description[locale],
                    };
                }

                return {
                    id,
                    source,
                    dest,
                    on: {
                        edit: () => this.edit(id),
                    },
                };
            });
        },
    },
    methods: {
        edit(id) {
            this.$router.push({
                name: 'transitions-node',
                params: { id },
            });
        },
    },
};
</script>

<style src="./TransitionsResults.scss" lang="scss"></style>
